import React, { useState } from 'react';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import { useSelector } from 'react-redux';
import { getUnitOfMeasures } from 'src/slices/unitOfMeasures';
import withValueField from './withValueField';
import FormSelect from 'shared/forms/FormSelect';

const UnitOfMeasureTelerikDropdown = (props) => {

  const unitOfMeasures = useSelector(getUnitOfMeasures).map(uom => {
    return {
      label: uom.unitOfMeasure,
      value: uom.id
    };
  });

  return (

    <>
      <FormSelect
        data={unitOfMeasures}
        textField="label"
        dataItemKey="value"
        {...props}
      />
    </>
  );
};

export default UnitOfMeasureTelerikDropdown;